<template>
  <div>
    <div class="newList">
       <div class="ItemList" id="NewsItem">
          <div class="NewsItem">
            <ul v-if="newsList1.length!=0" class="comUl" style="margin: 0;">
              <li v-for="(item, index) in newsList1" :key="index">
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                <a
                  v-else
                  @click="((val)=>{todel(val,item.entTArticleUuid)})"
                  >{{ item.title }}</a
                >
                <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
              </li>
            </ul>
            <el-divider v-if="newsList1.length==5"></el-divider>
            <ul v-if="newsList2.length!=0" class="comUl" style="margin: 0;">
              <li v-for="(item, index) in newsList2" :key="index">
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                <a
                  v-else
                  @click="((val)=>{todel(val,item.entTArticleUuid)})"
                  >{{ item.title }}</a
                >
                <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
              </li>
            </ul>
            <el-divider v-if="newsList2.length==5"></el-divider>
            <ul v-if="newsList3.length!=0" class="comUl" style="margin: 0;">
              <li v-for="(item, index) in newsList3" :key="index">
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                <a
                  v-else
                  @click="((val)=>{todel(val,item.entTArticleUuid)})"
                  >{{ item.title }}</a
                >
                <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
              </li>
            </ul>
            <el-divider v-if="newsList3.length==5"></el-divider>
          </div>
        </div>
    </div>
    <div class="pagin" v-if="totalPages>1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :pager-count="11"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { articles } from '@/api/common'
export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newsList: [],
      newsList1:[],
      newsList2:[],
      newsList3:[],
      pageSize: 15,
      pageNum: 1,
      total: 0,
      totalPages:0
    }
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 120) {
        return value.slice(0, 120) + '...'
      }
      return value
    }
  },
  computed: {},
  watch: {
    $route(val) {
      this.fullPath = val.fullPath
    }
  },
  mounted() {
    var _this = this
    this.$nextTick(() => {
      _this.articles()
    })
  },
  methods: {
    todel(val,entTArticleUuid){
      let routeUrl =  this.$router.resolve({path:this.fullPath,query:{entTArticleUuid:JSON.stringify(entTArticleUuid)}})
      window.open(routeUrl.href, '_blank')
    },
    articles() {
      var _this = this

      var listId = ''
      var applicationId = ''
      if (_this.id == '00550003') {
        listId = '00190001'
        applicationId = _this.webIdGroup
      } else {
        listId = _this.id
        applicationId = _this.webId
      }

      let data = {
        entTApplicationUuid: applicationId,
        channelUuid: listId,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsList = data.rows
          _this.total = data.totalRows
          _this.totalPages = data.totalPages
          _this.newsList1 = _this.newsList.slice(0,5)
          _this.newsList2 = _this.newsList.slice(5,10)
          _this.newsList3 = _this.newsList.slice(10,15)
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      var _this = this
      _this.pageNum = val
      _this.articles()
    }
  }
}
</script>

<style lang="scss">
.newList {
  width: 910px;
  height: auto;
  overflow: hidden;
  margin: 20px auto 0px;
}
.newList .el-divider--horizontal{
  margin: 10px 0;
}
.newList .ItemList {
  width: 100%;
  overflow: hidden;
}
.newList .ItemList .comUl {
  padding-left: 0px;
}
.newList .ItemList .comUl li {
  width: 100%;
  height: 38.4px;
  line-height: 38.4px;
  background: url(../../assets/image/li.jpg) left center no-repeat;
  text-indent: 1.2em;
}
.newList .ItemList .comUl li a {
  float: left;
  white-space: nowrap;
  display: block;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  color: #000000;
  font-size: 15px;
}

.newList .ItemList .comUl li a:hover {
  animation: comUla 0.2s linear 1;
  color: #4d4d44d4;
}
@keyframes comUla {
  from {
    transform: translateY(+1px);
  }
  to {
    transform: translateY(+1px);
  }
}
.pagin{
  text-align: center;
  margin-top: 20px;
}
.comUl li span {
  float: right;
  font-size: 15px;
}
</style>
